import { createApp } from "vue";
import { registerPlugins } from "@/plugins";
import App from "./App.vue";
import router from "./router";
import { initStore } from "./store";
import { authManager } from "@/services/authManager";

const app = createApp(App);

registerPlugins(app);

initStore();

app.use(router);

authManager.initialize();

app.unmount = (() => {
  const originalUnmount = app.unmount;
  return () => {
    authManager.cleanup();
    return originalUnmount();
  };
})();

app.mount("#app");
